export default __webpack_public_path__ + "images/6877752f1a1f1e56dd32bfb9b8021e20.svg";